import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/the-kingston-difference/layoutProps';

import image from './klt@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="kowloon-tong-community">
    <h1>九龍塘社區</h1>
    <p>
      京斯敦國際學校位於九龍塘的中心地帶，一處充滿濃厚歷史與文化的地方。京斯敦國際學校位於獅子山下，並與附近的廟宇及公園僅隔數分鐘之遙，鄰近本校的也是頂尖的學校與舒適的低密度住宅。學校旁寬敞的大道及路旁青蔥的樹木締造舒適悠閒的環境，令你停下腳步沉浸在這一片閒逸的環境中。九龍塘是一個獨特的社區，很多街道名稱均含有英國殖民地背景與特色。若有機會參觀京斯敦國際學校，請不要錯過九龍塘富特色的一面！
    </p>
    <img src={image} alt="Kowloon Tong Community" />
  </ContentLayout>
);
